import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";

import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { CampaignTypeWithTacos } from "@front/m19-models";
import { CampaignTypeBadgeComponent } from "@m19-board/shared/campaign-type-badge/campaign-type-badge.component";

@Component({
  selector: "app-campaign-type-badge-grid",
  imports: [CampaignTypeBadgeComponent],
  template: ` @if (campaignType(); as campaignType) {
    <app-campaign-type-badge [campaignType]="campaignType" [tacosSpStrategyId]="tacosSpStrategyId()" />
  }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignTypeBadgeGridComponent implements ICellRendererAngularComp {
  campaignType = signal<CampaignTypeWithTacos | undefined>(undefined);
  tacosSpStrategyId = signal<number | undefined>(undefined);

  agInit(params: ICellRendererParams & { campaignType: CampaignTypeWithTacos; tacosSpStrategyId?: number }): void {
    this.campaignType.set(params.campaignType);
    this.tacosSpStrategyId.set(params.tacosSpStrategyId);
  }

  refresh(params: ICellRendererParams<any>): boolean {
    return false;
  }
}
